const getters = {
    occasion(state) {
        return state.occasion;
    },
    addonProducts(state) {
        return state.addonProducts;
    },
    rtsProducts(state) {
        return state.rtsProducts;
    },
    gocProducts(state) {
        return state.gocProducts;
    },
    gocImage(state){
        return state.gocImage;
    },
    waysImages(state){
        return state.waysImages;
    },
    headers(state){
        return state.headers;
    },
    slides(state){
        return state.slides;
    },
};

export default getters;
